import type { StaffDetail } from "@/api/guide";
import { THEME, WEEK_MAP } from "../constants";

interface WorkInfoProps {
  guide: StaffDetail;
}

export default function WorkInfo({ guide }: WorkInfoProps) {
  if (!guide.place && !guide.workTime.start) return null;

  return (
    <div className="mx-4 mt-4 p-4 rounded-2xl space-y-3" style={{ background: "rgba(255,255,255,0.05)" }}>
      {guide.workTime.start && (
        <div className="flex items-center gap-3">
          <i className="ri-time-line" style={{ fontSize: 16, color: THEME.primary }} />
          <span className="text-xs" style={{ color: "rgba(255,255,255,0.65)" }}>
            工作时间：<span className="text-white font-medium">{guide.workTime.start} - {guide.workTime.end}</span>
            {guide.weekStr && (
              <span className="ml-2" style={{ color: "rgba(255,255,255,0.45)" }}>
                ({guide.weekStr.split(",").filter(Boolean).map(w => WEEK_MAP[w] || w).join("、")})
              </span>
            )}
          </span>
        </div>
      )}
      {guide.place && (
        <div className="flex items-start gap-3">
          <i className="ri-map-pin-line" style={{ fontSize: 16, color: THEME.primary, marginTop: 1 }} />
          <span className="text-xs leading-relaxed" style={{ color: "rgba(255,255,255,0.65)" }}>
            服务地址：<span className="text-white font-medium">{guide.place}</span>
            {guide.serviceRadius && (
              <span className="ml-2" style={{ color: "rgba(255,255,255,0.45)" }}>(服务半径 {guide.serviceRadius}km)</span>
            )}
          </span>
        </div>
      )}
      {guide.currentAddress && (
        <div className="flex items-start gap-3">
          <i className="ri-navigation-line" style={{ fontSize: 16, color: THEME.primary, marginTop: 1 }} />
          <span className="text-xs leading-relaxed" style={{ color: "rgba(255,255,255,0.45)" }}>
            当前位置：{guide.currentAddress}
          </span>
        </div>
      )}
    </div>
  );
}
